import { useEffect, useState } from 'react';

/**
 * Returns `value` after it has stopped changing for `delay` ms. Used to
 * throttle expensive work (network calls, large filters) driven by fast-
 * changing inputs like the keystrokes of a search field.
 *
 * Re-renders only when the debounced output actually flips — keystrokes
 * within the window don't trigger downstream consumers.
 */
export function useDebouncedValue<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
